import {
  useBrokersServiceBrokersBrokersMediaDestroy,
  useBrokersServiceBrokersBrokersMediaListKey
} from '@insurance/api/queries'
import { showApiErrors } from '@shared/utils'
import { useQueryClient } from '@tanstack/react-query'
import { App, Modal } from 'antd'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { CommonPropsMedia } from './types'

export const DeleteMedia = ({
  data,
  onSuccess,
  open,
  onCancel
}: CommonPropsMedia) => {
  const { t } = useTranslation()
  const [modal, contextHolder] = Modal.useModal()
  const { message } = App.useApp()
  const queryClient = useQueryClient()

  const { mutateAsync: deleteMutation } =
    useBrokersServiceBrokersBrokersMediaDestroy({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [useBrokersServiceBrokersBrokersMediaListKey]
        })

        message.success(t('removed_successfully'))

        onSuccess()
      },
      onError: (error) => showApiErrors(error)
    })

  useEffect(() => {
    const id = data?.id
    if (!id) return

    const { destroy } = modal.confirm({
      title: t('delete_confirm'),
      content: (
        <span
          dangerouslySetInnerHTML={{
            __html: t('delete_confirm_description_media', {
              name: data?.media?.name || String(data.id)
            })
          }}
        />
      ),
      okText: t('delete'),
      cancelText: t('cancel'),
      okType: 'danger',
      onOk: () => deleteMutation({ id }),
      open,
      onCancel
    })

    return destroy
  }, [data, deleteMutation, modal, onCancel, open, t])

  return contextHolder
}
